import { render, staticRenderFns } from "./TabelRegisterKebidanan.vue?vue&type=template&id=686ebd2d&scoped=true&"
import script from "./TabelRegisterKebidanan.vue?vue&type=script&lang=ts&"
export * from "./TabelRegisterKebidanan.vue?vue&type=script&lang=ts&"
import style0 from "./TabelRegisterKebidanan.vue?vue&type=style&index=0&id=686ebd2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ebd2d",
  null
  
)

export default component.exports